import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { Card } from '@components/card';
import { Stack } from '@components/stack';

import { IntegrationField } from 'components/IntegrationField';
import { IntegrationHeader } from 'components/IntegrationHeader';
import { Loading } from 'components/Loading';
import { useStore } from 'models/Provider';

export const H3coreOnboarding = observer(
  ({ integration, saving, submit, validator, validating }) => {
    integration.loadForApplication();
    const { t } = useStore();
    return (
      <Stack space={6}>
        <IntegrationHeader integration={integration} />
        {(integration.state === 'loading' || integration.refetching) && <Loading />}
        {integration.state !== 'loading' && !integration.triggered && (
          <Stack space={4}>
            {integration.data.map((data, i) => (
              <IntegrationField
                data={data}
                validator={validator}
                refetch={integration.refetchForApplication}
                key={i}
                isDisabled={saving || integration.refetching}
              />
            ))}
            <Stack space={2} orientation="horizontal" justify="flex-end">
              <Button
                variant="primary-blue"
                isDisabled={saving || integration.refetching}
                onClick={() => submit(false, true)}
                text={t('application.onboarding.integration.save')}
              />
              <Button
                isDisabled={
                  saving ||
                  integration.refetching ||
                  integration.isBlocked ||
                  validating ||
                  integration.hasErrors()
                }
                onClick={() => submit(false, false)}
                text={t('application.onboarding.integration.submit')}
              />
            </Stack>
          </Stack>
        )}
        {integration.state !== 'loading' && integration.triggered && (
          <Card space={6}>
            <Stack space={4}>
              {integration.data.map((data, i) => (
                <IntegrationField data={data} validator={validator} key={i} readOnly />
              ))}
            </Stack>
          </Card>
        )}
      </Stack>
    );
  },
);
